import { render, staticRenderFns } from "./addPermissionAction.vue?vue&type=template&id=943e6674&"
import script from "./addPermissionAction.vue?vue&type=script&lang=js&"
export * from "./addPermissionAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports